import { ChevronRightIcon } from "@heroicons/react/24/outline";
import * as React from "react";

interface IContentSectionBreadcrumbsProps {
  segments: string[];
}

export default function ContentSectionBreadcrumbs({ segments }: IContentSectionBreadcrumbsProps) {
  return (
    <>
      <div className="hidden items-center space-x-1 font-aeonik text-sm font-medium tracking-wide text-slate-500 xl:flex">
        {segments.map((segment, index) => {
          return (
            <React.Fragment key={segment}>
              {index > 0 && <ChevronRightIcon className="mt-[1px] inline-flex h-3 w-3" strokeWidth={3} />}
              <span key={segment}>{segment}</span>
            </React.Fragment>
          );
        })}
      </div>

      <span className="flex max-w-xs items-center space-x-1 font-aeonik text-sm font-medium tracking-wide text-slate-500 xl:hidden">
        {segments[segments.length - 1]}
      </span>
    </>
  );
}
